export const listBuilderEn = {
  pageTitle: 'List Builder',
  pageSubtitle: 'Preload your knowledge about what to do and where to stay in each city. Manage all items here—they will be available when planning itineraries.',

  backToClients: 'Back to Clients',

  nav: {
    allItems: 'All Items',
    byCity: 'By City',
    cities: 'Cities',
  },

  cities: {
    title: 'Cities',
    addCity: 'Add city',
    editCity: 'Edit city',
    deleteCity: 'Delete city',
    name: 'City name',
    country: 'Country',
    region: 'Region',
    notes: 'Notes',
    unknownCountry: 'Other',
    noCities: 'No cities yet.',
    noCitiesDescription: 'Add a city first, then attach activities, meals, and hotels.',

    form: {
      name: 'City name',
      namePlaceholder: 'e.g. Paris',
      country: 'Country',
      countryPlaceholder: 'e.g. France',
      region: 'Region',
      regionPlaceholder: 'e.g. Île-de-France',
      notes: 'Notes',
      notesPlaceholder: 'Optional notes about the city',
      historySummary: 'History summary',
      historySummaryPlaceholder: 'Brief history or context for this city',
    },
  },

  activities: {
    title: 'Activities',
    addActivity: 'Add activity',
    editActivity: 'Edit activity',
    deleteActivity: 'Delete activity',
    name: 'Name',
    noActivities: 'No activities for this city.',
    noActivitiesDescription: 'Add activities you want to do in this city.',

    form: {
      city: 'City',
      cityPlaceholder: 'Select city',
      title: 'Title',
      titlePlaceholder: 'e.g. Louvre Museum',
      description: 'Description',
      descriptionPlaceholder: 'Brief description',
      operatingHours: 'Operating hours',
      operatingHoursPlaceholder: 'e.g. 9am–6pm Tue–Sun',
      recommendedTimes: 'Recommended times',
      recommendedTimesPlaceholder: 'e.g. morning, afternoon (comma-separated)',
      bestTimeReason: 'Best time reason',
      bestTimeReasonPlaceholder: 'Why this time is best',
      area: 'Area / neighborhood',
      areaPlaceholder: 'e.g. 1st arrondissement',
      url: 'URL',
      urlPlaceholder: 'https://...',
      suggestedDurationMinutes: 'Suggested duration (minutes)',
      transit: 'Transit',
      transitPlaceholder: 'How to get there',
      transitOptions: {
        walk: 'Walk',
        metro: 'Metro',
        tram: 'Tram',
        bus: 'Bus',
        rideshare: 'Rideshare',
        bike: 'Bike',
      },
      kidFriendly: 'Kid friendly',
      accessibilityNotes: 'Accessibility notes',
      accessibilityNotesPlaceholder: 'Accessibility information',
      priceCategory: 'Price category',
      priceOptions: {
        free: 'Free',
        $: '$',
        '$$': '$$',
        '$$$': '$$$',
        '$$$$': '$$$$',
      },
      tags: 'Tags',
      tagsPlaceholder: 'e.g. museum, art (comma-separated)',
      recommendedIfStayAtLeastDays: 'Recommended if stay at least (days)',
      latitude: 'Latitude',
      longitude: 'Longitude',
    },
  },

  meals: {
    title: 'Meals & Restaurants',
    addMeal: 'Add restaurant or meal',
    editMeal: 'Edit meal',
    deleteMeal: 'Delete meal',
    name: 'Name',
    noMeals: 'No restaurants for this city.',
    noMealsDescription: 'Add restaurants you want to try.',

    form: {
      city: 'City',
      cityPlaceholder: 'Select city',
      name: 'Name',
      namePlaceholder: 'e.g. Le Comptoir du Relais',
      cuisine: 'Cuisine',
      cuisinePlaceholder: 'e.g. French bistro',
      description: 'Description',
      descriptionPlaceholder: 'Brief description',
      operatingHours: 'Operating hours',
      operatingHoursPlaceholder: 'e.g. 8am–11pm',
      priceCategory: 'Price category',
      priceOptions: {
        free: 'Free',
        $: '$',
        '$$': '$$',
        '$$$': '$$$',
        '$$$$': '$$$$',
      },
      area: 'Area / neighborhood',
      areaPlaceholder: 'e.g. Saint-Germain',
      url: 'URL',
      urlPlaceholder: 'https://...',
      matchScore: 'Match score',
      reasoning: 'Reasoning',
      reasoningPlaceholder: 'Why this restaurant',
      reservationRequirement: 'Reservation requirement',
      reservationOptions: {
        required: 'Required',
        recommended: 'Recommended',
        not_needed: 'Not needed',
      },
      kidFriendly: 'Kid friendly',
      tags: 'Tags',
      tagsPlaceholder: 'e.g. romantic, casual (comma-separated)',
      latitude: 'Latitude',
      longitude: 'Longitude',
    },
  },

  hotels: {
    title: 'Hotels & Stays',
    addHotel: 'Add hotel',
    editHotel: 'Edit hotel',
    deleteHotel: 'Delete hotel',
    name: 'Name',
    noHotels: 'No hotels for this city.',
    noHotelsDescription: 'Add hotels you want to stay at or recommend.',

    form: {
      city: 'City',
      cityPlaceholder: 'Select city',
      name: 'Name',
      namePlaceholder: 'e.g. Hôtel du Louvre',
      description: 'Description',
      descriptionPlaceholder: 'Brief description',
      budgetCategory: 'Budget category',
      budgetCategoryPlaceholder: 'e.g. mid-range, luxury',
      pricePerNight: 'Price per night',
      currency: 'Currency',
      currencyPlaceholder: 'e.g. USD, EUR',
      area: 'Area / neighborhood',
      areaPlaceholder: 'e.g. Marais, 1st arr.',
      url: 'URL',
      urlPlaceholder: 'https://...',
      amenities: 'Amenities',
      amenitiesPlaceholder: 'e.g. pool, wifi (comma-separated)',
      rating: 'Rating',
      familyNotes: 'Family notes',
      familyNotesPlaceholder: 'Notes for families',
      accessibilityNotes: 'Accessibility notes',
      accessibilityNotesPlaceholder: 'Accessibility information',
      tags: 'Tags',
      tagsPlaceholder: 'e.g. boutique, historic (comma-separated)',
      latitude: 'Latitude',
      longitude: 'Longitude',
    },
  },

  buttons: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    add: 'Add',
    edit: 'Edit',
  },

  address: {
    sectionTitle: 'Address',
    line1: 'Address Line 1',
    line1Placeholder: 'Street address',
    line2: 'Address Line 2',
    line2Placeholder: 'Apt, suite, unit, etc. (optional)',
    city: 'City',
    cityPlaceholder: 'City',
    state: 'State / Province',
    statePlaceholder: 'State or province',
    postalCode: 'Postal Code',
    postalCodePlaceholder: 'ZIP or postal code',
    country: 'Country',
    countryPlaceholder: 'Country',
    phoneNumber: 'Phone Number',
    phoneNumberPlaceholder: 'e.g. +1 555-123-4567',
  },

  confirmDelete: (itemName: string): string =>
    `Delete "${itemName}"? This cannot be undone.`,
  confirmDeleteCity: (cityName: string): string =>
    `Delete "${cityName}" and all its activities, meals, and hotels? This cannot be undone.`,

  stats: {
    cities: 'cities',
    activities: 'activities',
    meals: 'meals',
    hotels: 'hotels',
  },

  emptyState: {
    title: 'Your list builder is empty.',
    description: 'Add cities, then attach activities, meals, and hotels. When you plan itineraries, this knowledge will be at your fingertips.',
  },

  allItems: {
    title: 'All Items',
    subtitle: 'View and manage all your saved items.',
    activities: 'Activities',
    meals: 'Meals & Restaurants',
    hotels: 'Hotels',
    inCity: (cityName: string): string => `in ${cityName}`,
  },
} as const;
